import _ from 'underscore';
import React from 'react';
import { Mode } from '@bingads-webui-react/app-layout-container';
import { ElementSelector } from '@bingads-webui-campaign-react/element-selector';
import { MerchantCenterMainMenu } from '@bingads-webui-campaign-react/merchant-center-main-menu';
import { CampaignMainMenu } from '@bingads-webui-campaign-react/main-menu';
import { ReportsV4MainMenu } from '@bingads-webui-campaign-react/reports-v4-main-menu';
import { ImportCenterMainMenu } from '@bingads-webui-campaign-react/import-center-main-menu';
import { CampaignMainMenuPlaceholder } from '@bingads-webui-campaign-react/shell-ui-common';
import {
  withSiteMap,
  withToolsSiteMap,
  withReportsV4SiteMap,
  withImportSiteMap,
  processorSet,
  Configs,
} from '@bingads-webui-campaign-react/with-site-map';
import { StateStore } from '@bingads-webui/state-store';
import { withStateStore } from '@bingads-webui/with-state-store';
import { SiteMapElementLoader } from './site-map-element-loader';

export const isHamburgerVisibleStore = new StateStore({
  isHamburgerVisible: false,
  isPanelMode: false,
});

const assetsDetailSiteMap = _.findWhere(Configs.standaloneSiteMap, { id: 'pmax-asset-details' });
const campaignWithAssetsSiteMap = _.union(Configs.campaignSiteMap, [assetsDetailSiteMap]);

const MerchantCenterLoader = withToolsSiteMap(
  SiteMapElementLoader,
  processorSet.all,
  'merchant-center/*'
);

const ImportCenterLoader = withImportSiteMap(
  SiteMapElementLoader,
  processorSet.all,
  'import-center/*'
);

const ReportV4Loader = withReportsV4SiteMap(
  SiteMapElementLoader,
  processorSet.all,
  'reports-v4/*'
);

const CampaignLoader = withSiteMap(
  SiteMapElementLoader,
  processorSet.all,
  campaignWithAssetsSiteMap
);

const setIsHamburgerVisible = (elementAvailableStatuses, props) => {
  let isHamburgerVisible = false;

  if (props.mode !== Mode.Hidden) {
    _.each(elementAvailableStatuses, (status) => {
      if (status) {
        isHamburgerVisible = true;
      }
    });
  }

  isHamburgerVisibleStore.setState({
    isHamburgerVisible,
  });
};

const CampaignMainMenuWithStateStore = withStateStore(CampaignMainMenu, isHamburgerVisibleStore, store => ({ hamburgerStore: store }));
const MerchantCenterMenuWithStateStore = withStateStore(MerchantCenterMainMenu, isHamburgerVisibleStore, store => ({ hamburgerStore: store }));
const ReportV4MainMenuWithStateStore = withStateStore(ReportsV4MainMenu, isHamburgerVisibleStore, store => ({ hamburgerStore: store }));
const ImportCenterMainMenuWithStateStore = withStateStore(ImportCenterMainMenu, isHamburgerVisibleStore, store => ({ hamburgerStore: store }));


export const MainMenuContainer = React.memo(props => (
  <ElementSelector fallback={(<CampaignMainMenuPlaceholder />)} onSelectionChange={elementAvailableStatuses => setIsHamburgerVisible(elementAvailableStatuses, props)}>
    <MerchantCenterLoader Component={MerchantCenterMenuWithStateStore} {...props} />
    <ReportV4Loader Component={ReportV4MainMenuWithStateStore} {...props} />
    <ImportCenterLoader Component={ImportCenterMainMenuWithStateStore} {...props} />
    <CampaignLoader
      Component={CampaignMainMenuWithStateStore}
      {...props}
    />
  </ElementSelector>
));
